import { apiGetV3 } from '../utils/api'
import { convertJsonApiDataToList } from '../utils/common'


export const getConsumerTypes = () => {
    return apiGetV3('consumer-types')
            .then(response => convertJsonApiDataToList(response.data || []))
            .catch(error => {
                console.error('Failed to fetch consumer types:', error);
                return null;
              });
}
  


// WEBPACK FOOTER //
// ./src/api/consumer-type.js